export default "__VITE_ASSET__CGhFiW$H__"